<template>
  <v-container fluid>
    <v-card min-height="50vh">
      <v-toolbar color="indigo" dense class="rounded rounded-b-0">
        <v-toolbar-title class="white--text"> Calendari </v-toolbar-title>
        <!-- <CalendarioGenerico
            @click_chiudi="dialog_calendario_generico = false" ref="ref_generico"
          /> -->
      </v-toolbar>
      <div class="mt-5 text-start">
        <v-row v-for="(item, i) in items_treeview" :key="i">
          <v-col
            cols="12"
            v-if="item.id_rif == null || isVisible(item)"
            :style="{
              paddingLeft:
                (item.livello + 1) * 30 + (item.livello == 4 ? 10 : 0) + 'px',
            }"
            :key="isVisible(item)"
          >
            <v-icon
              v-if="item.expand"
              @click="chiudiNodi(item)"
              v-show="item.livello < 4"
              color="#0275d8"
              >mdi-chevron-down</v-icon
            >
            <v-icon
              v-else
              v-show="item.livello < 4"
              color="#0275d8"
              @click="item.expand = true"
              >mdi-chevron-right</v-icon
            >
            {{ item.des }}
            <v-icon
              v-if="item.livello == 0 || item.livello == 1"
              color="#0275d8"
              @click="i == 0 ? apriDialog(item) : selezionaCalendario(item)"
              >mdi-calendar</v-icon
            >
            <v-icon
              v-if="i != 0"
              :color="item.eccezione ? 'orange' : '#0275d8'"
              @click="apriCalendarioSpecifico(item)"
              >mdi-calendar-star</v-icon
            >
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog v-model="dialog_calendario" persistent width="60vw">
      <v-card min-height="40vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-row class="d-flex justify-center align-center">
            <v-col cols="4" class="text-start">
              <v-toolbar-title class="white--text">
                Calendario
              </v-toolbar-title>
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
              <v-tooltip bottom v-if="calendario_dettaglio">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="
                      calendario_dettaglio
                        ? salvaCalendario()
                        : salvaAssociazione()
                    "
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" class="d-flex justify-start">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="
                      calendario_dettaglio
                        ? aggiungiTurno()
                        : aggiungiCalendario()
                    "
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="primary"> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  calendario_dettaglio ? "Aggiungi turno" : "Crea calendario"
                }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="4" class="text-end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-5"
                    @click="
                      calendario_dettaglio
                        ? (calendario_dettaglio = false)
                        : (dialog_calendario = false)
                    "
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="error">
                      {{
                        calendario_dettaglio
                          ? "mdi-keyboard-backspace"
                          : "mdi-close"
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Indietro</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>
        <!-- Lista Calendari -->
        <v-card-text class="mt-5 mb-0 pb-5" v-if="!calendario_dettaglio">
          <v-data-table :items="lista_calendari" :headers="headers">
            <template v-slot:[`item.edit`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    style="align-self: self-start"
                    @click="
                      selectCalendarioOrari(item);
                      calendario_dettaglio = true;
                    "
                  >
                    <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Dettagli</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.delete`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      selectItem(item);
                      dialog_delete = true;
                    "
                  >
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- Aggiungi/Modifica Calendario -->
        <v-card-text v-if="calendario_dettaglio" class="mt-3 mb-0 pb-5">
          <v-row class="d-flex justify-center">
            <v-col cols="6" class="mt-2">
              <v-text-field
                dense
                label="Nome Calendario"
                v-model="selected_item.des_calendario"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="d-flex justify-center align-center"
            v-for="(f, i) in fasce.filter((f) => f.validita == 1)"
            :key="i"
          >
            <v-col cols="4" class="d-flex align-center justify-center">
              <v-select
                dense
                label="Giorni"
                v-model="f.num_giorno"
                :items="items_giorni"
                item-text="des"
                item-value="val_int"
              ></v-select>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">
              <v-text-field
                dense
                v-model="f.ora_da"
                label="Dalle ore"
                type="time"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">
              <v-text-field
                dense
                v-model="f.ora_a"
                label="Alle ore"
                type="time"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-tooltip bottom v-if="i > 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="f.validita = 0" v-bind="attrs" v-on="on" small>
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Rimuovi turno</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog Delete -->
    <v-dialog persistent v-model="dialog_delete" width="400px">
      <v-card min-height="20vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                @click="eliminaCalendario"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="dialog_delete = false"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-5">
          <p class="black--text">
            Sei sicuro di voler eliminare il calendario
            {{ selected_item.des_calendario }}?
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog Delete -->
    <v-dialog persistent v-model="dialog_calendario_relazioni" width="400px">
      <v-card min-height="20vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            {{ azienda_sel }}
          </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                @click="salvaAssociazione()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="dialog_calendario_relazioni = false"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-5">
          <v-select
            dense
            @change="getDettaglioCalendarioSelezionato()"
            label="Calendario"
            v-model="calendario_relazione_new.id_calendario"
            :items="lista_calendari"
            item-text="des_calendario"
            item-value="id_calendario"
          ></v-select>
          <v-row
            class="d-flex justify-center align-center"
            v-for="(f, i) in fasce"
            :key="i"
          >
            <v-col cols="6" class="d-flex align-center justify-center">
              <v-select
                dense
                disabled
                label="Giorni"
                v-model="f.num_giorno"
                :items="items_giorni"
                item-text="des"
                item-value="val_int"
              ></v-select>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center">
              <v-text-field
                disabled
                dense
                v-model="f.ora_da"
                label="Dalle ore"
                type="time"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center">
              <v-text-field
                disabled
                dense
                v-model="f.ora_a"
                label="Alle ore"
                type="time"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          getEccezioniLista(calendario_specifico.tipo);
        "
        :id_riferimento="calendario_specifico.id_riferimento"
        :tipo="calendario_specifico.tipo"
      />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" :z-index="10000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "QLCalendariTrieeview",

  components: {
    SnackbarQV,
    CalendarioSpecifico,
    // CalendarioGenerico,
    // AziendaCal
  },
  props: {},

  data() {
    return {
      // Variabili d'appoggio
      overlay: false,
      azienda_sel: "",
      calendario_relazione_new: {
        id_calendario: null,
        id_relazione: -1,
        id_riferimento: null,
        pk_riferimento: "id_azienda_sede",
        cod_riferimento: "t_azienda_sedi",
        validita: 1,
      },
      selected_item: {
        id_calendario: -1,
        des_calendario: "",
        validita: 1,
        // priorita: 1,
      },
      calendario_specifico: {
        id_riferimento: null,
        tipo: null,
      },
      // Modal
      dialog_calendario: false,
      dialog_calendario_specifico: false,
      dialog_calendario_relazioni: false,
      dialog_delete: false,
      calendario_dettaglio: false,
      // Array
      relazioni_sel: [],
      lista_calendari: [],
      lista_calendari_orari: [],
      lista_eccezioni: [],
      lista_macchine: [],
      items_giorni: [],
      fasce: [
        {
          id_calendario_orario: -1,
          num_giorno: -1,
          ora_da: "08:00:00",
          ora_a: "12:00:00",
          validita: 1,
        },
      ],
      items_treeview:[],
      items: [
        {
          tipo: "azienda",
          id_rif: null,
          id: 1,
          des: localStorage.getItem("cod_azienda"),
          expand: true,
          livello: 0,
        },
      ],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
          width: "100px",
        },
        {
          text: "Nome",
          value: "des_calendario",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
          width: "50px",
        },
      ],
    };
  },

  computed: {},

  methods: {
    async salvaAssociazione() {
      this.relazioni_sel = [];
      this.relazioni_sel.push(this.calendario_relazione_new);
      const request = {
        controller: "logistic",
        method: "PUT",
        richiesta: {
          action: "savecalendariorelazioni",
          token: localStorage.getItem("user_token"),
          relazioni: this.relazioni_sel,
        },
      };
      this.overlay = true;
      await this.$store.dispatch("api6", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);

          this.getCalendarioRelazioni();
          this.dialog_calendario_relazioni = false;
          this.overlay = false;
        } else {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    eliminaCalendario() {
      this.fasce = [];
      this.selected_item.validita = 0;
      this.salvaCalendario();
    },
    async salvaCalendario() {
      if (
        !this.selected_item.des_calendario ||
        this.selected_item.des_calendario == ""
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          `Inserire nome calendario.`
        );
      }
      if (
        this.fasce.filter((f) => f.ora_da == null && f.validita == 1)?.length !=
          0 &&
        this.fasce.filter((f) => f.ora_a == null && f.validita == 1)?.length != 0
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          `Inserire gli orari in tutti i turni.`
        );
      }
      const request = {
        controller: "logistic",
        method: "PUT",
        richiesta: {
          action: "savecalendario",
          token: localStorage.getItem("user_token"),
          calendario: this.selected_item,
          fasce: this.fasce,
        },
      };
      this.overlay = true;
      await this.$store.dispatch("api6", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", `Salvataggio effettuato.`);

          this.getCalendari();
          this.calendario_dettaglio = false;
          this.dialog_delete = false;
          this.fasce = [
            {
              id_calendario_orario: -1,
              num_giorno: -1,
              ora_da: "08:00:00",
              ora_a: "12:00:00",
              validita: 1,
            },
          ];
          this.overlay = false;
        } else {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    aggiungiTurno() {
      this.fasce.push({
        id_calendario_orario: -1,
        num_giorno: -1,
        ora_da: "08:00",
        ora_a: "08:00",
        validita: 1,
      });
    },
    aggiungiSede(item) {
      if (
        this.relazioni_sel.filter((i) => i.id_riferimento == item.id)?.length ==
        0
      ) {
        this.relazioni_sel.push({
          id_calendario: this.selected_item.id_calendario,
          id_relazione: -1,
          id_riferimento: item.id,
          pk_riferimento: "id_azienda_sede",
          cod_riferimento: "t_azienda_sedi",
          validita: 1,
        });
      } else
        this.relazioni_sel.find(
          (i) => i.id_riferimento == item.id
        ).validita = 1;
    },
    eliminaRelazione(item) {
      this.relazioni_sel.find((i) => i.id_riferimento == item.id).validita = 0;
    },
    aggiungiCalendario() {
      this.selected_item = {
        id_calendario: -1,
        des_calendario: "",
        validita: 1,
      };
      this.fasce = [
        {
          id_calendario_orario: -1,
          num_giorno: -1,
          ora_da: "08:00:00",
          ora_a: "12:00:00",
          validita: 1,
        },
      ];
      this.calendario_dettaglio = true;
    },
    async getDettaglioCalendarioSelezionato() {
      if (this.calendario_relazione_new.id_calendario != null) {
        this.overlay = true;
        await this.getCalendarioDettaglio(
          this.calendario_relazione_new.id_calendario
        );
        this.overlay = false;
      }
      let orari_filtrati = this.lista_calendari_orari.filter(
        (i) => i.id_calendario == this.calendario_relazione_new.id_calendario
      );
      if (orari_filtrati?.length > 0) {
        this.fasce = Array.from(orari_filtrati);
      } else {
        this.fasce = [];
      }
    },
    async selectCalendarioOrari(item) {
      if (item.id_calendario != -1) {
        this.overlay = true;
        await this.getCalendarioDettaglio(item.id_calendario);
        this.overlay = false;
      }
      this.selectItem(item);
      let orari_filtrati = this.lista_calendari_orari.filter(
        (i) => i.id_calendario == item.id_calendario
      );
      if (orari_filtrati?.length > 0) {
        this.fasce = Array.from(orari_filtrati);
      }
    },
    selectItem(i) {
      this.selected_item = {
        id_calendario: i.id_calendario,
        des_calendario: i.des_calendario,
        priorita: i.priorita,
        validita: i.validita,
      };
    },
    chiudiNodi(i) {
      i.expand = false;
      this.items_treeview
        .filter((item) => item.livello == i.livello + 1)
        .forEach((item) => {
          if (item.id_rif == i.id) {
            item.expand = false;
            this.chiudiNodi(item);
          }
        });
    },
    async apriDialog() {
      this.overlay = true;
      await this.getCalendari();
      this.dialog_calendario = true;
      this.overlay = false;
    },
    async selezionaCalendario(item) {
      this.overlay = true;
      this.azienda_sel = item.des;
      await this.getCalendari();
      await this.getCalendarioRelazioni();
      if (
        this.relazioni_sel?.filter((r) => r.id_riferimento == item.id)?.length > 0
      ) {
        this.calendario_relazione_new = this.relazioni_sel.find(
          (r) => r.id_riferimento == item.id
        );
        this.getDettaglioCalendarioSelezionato();
      } else {
        this.fasce = [];
        this.calendario_relazione_new = {
          id_calendario: null,
          id_relazione: -1,
          id_riferimento: item.id,
          pk_riferimento: "id_azienda_sede",
          cod_riferimento: "t_azienda_sedi",
          validita: 1,
        };
      }
      this.dialog_calendario_relazioni = true;
    },
    apriCalendarioSpecifico(i) {
      this.calendario_specifico.id_riferimento = i.id;
      this.calendario_specifico.tipo = i.livello;
      this.dialog_calendario_specifico = true;
    },
    isVisible(item) {
      let tempItems = [];
      switch (item.livello) {
        // azienda
        case 0:
          break;
        // sedi
        case 1:
          tempItems = this.items_treeview.filter((i) => i.tipo == "azienda");
          break;
        // reparti
        case 2:
          tempItems = this.items_treeview.filter((i) => i.tipo == "sedi");
          break;
        // veicoli
        case 3:
          tempItems = this.items_treeview.filter((i) => i.tipo == "reparto");
          break;
        // autisti
        case 4:
          tempItems = this.items_treeview.filter((i) => i.tipo == "veicoli");
          break;
      }
      let result = false;
      if (item.id_rif != null) {
        if (tempItems.filter((e) => e.id == item.id_rif)?.length > 0) {
          if (tempItems.find((e) => e.id == item.id_rif).expand) {
            result = true;
          }
        }
      }
      return result;
    },
    changeComponent(item) {
      this.$emit("changeComponent", item);
    },
    async getSedi() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedi",
          id_azienda: 1,
          id_azienda_sede: null,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result?.length > 0) {
              let arrTemp =
                res.data.result?.length > 0
                  ? res.data.result.sort((a, b) =>
                      this.sortByDesc(b.descrizione, a.descrizione)
                    )
                  : [];
              arrTemp.forEach((s) => {
                this.items.push({
                  tipo: "sedi",
                  id: s.id_azienda_sede,
                  id_rif: s.id_azienda,
                  des: s.descrizione,
                  expand: false,
                  livello: 1,
                });
              });
            }
            this.getEccezioniLista(1);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    async getReparti(id_sede) {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedereparti",
          id_azienda: 1,
          id_azienda_sede: id_sede,
          id_azienda_sede_reparto: null,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.result?.length > 0) {
          res.data.result.forEach((s) => {
            this.items.push({
              tipo: "reparto",
              id: s.id_azienda_sede_reparto,
              id_rif: s.id_azienda_sede,
              des: s.descrizione,
              expand: false,
              livello: 2,
            });
          });
        }

        this.getEccezioniLista(2);
      });
    },
    async getMacchine() {
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.macchine.forEach((v) => {
              this.lista_macchine.push(v);
              this.items.push({
                tipo: "veicoli",
                id: v.id_macchina,
                id_rif: v.id_reparto,
                des: v.des_macchina,
                expand: false,
                livello: 3,
              });
            });
            this.getEccezioniLista(3);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    sortByDesc(strA, strB) {
      // Convert undefined or null to empty string
      strA = (strA || "").trim().toLowerCase();
      strB = (strB || "").trim().toLowerCase();
      if (strA === "") return -1;
      if (strB === "") return 1;
      // Compare the strings
      if (strA < strB) return 1;
      if (strA > strB) return -1;
      return 0;
    },
    async getCalendarioRelazioni() {
      this.overlay = true;
      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getcalendariorelazioni",
          token: localStorage.getItem("user_token"),
          pk_riferimento: "id_azienda_sede",
          cod_riferimento: "t_azienda_sedi",
        },
      };
      await this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status === 200) {
            this.relazioni_sel = res.data.result.relazioni;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore durante il caricamento dei dati`
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore durante il caricamento dei dati`
          );
        });
      this.overlay = false;
    },
    async getTabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "CALENDARIO_GIORNI",
          filter: "validita = 1",
        },
      };
      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data?.length > 0) {
              this.items_giorni = Array.from(
                res.data.sort((a, b) => a.ordine - b.ordine)
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata. Stato: ${res.status}`
            );
          }
        })
        .catch((e) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(e.response.data.message).result}.`
          );
        });
    },

    async getCalendari() {
      const request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getcalendario",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_calendari = [];
          this.lista_calendari_orari = [];
          if (res.data?.length > 0) {
            this.lista_calendari = Array.from(res.data);
          }
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    async getCalendarioDettaglio(id) {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getcalendariodettaglio",
          id_calendario: id,
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        this.lista_calendari_orari = [];
        if (res.data.calendario?.length > 0) {
          this.lista_calendari_orari = Array.from(res.data.calendario);
        }
      });
    },
    getEccezioniLista(tipo) {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: tipo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          if (res.data.calendario_ecc?.length > 0) {
            this.lista_eccezioni = this.lista_eccezioni.concat(
              res.data.calendario_ecc
            );
            this.items
              .filter((i) => i.livello == tipo)
              .forEach((item) => {
                item.eccezione = false;
                this.lista_eccezioni
                  .filter((e) => e.tipo == tipo)
                  .forEach((ecc) => {
                    if (item.id == ecc.rif_calendario) {
                      item.eccezione = true;
                    }
                  });
              });
          }
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },
    async getConduttoriMacchine() {
      let getconduttoremacchine = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getconduttoremacchine",
          token: localStorage.getItem("user_token"),
          id_conduttore: null,
          id_conduttore_macchina: null,
        },
      };
      await this.$store.dispatch("api6", getconduttoremacchine).then((res) => {
        if (res.status == 200) {
          res.data.result.forEach((e) => {
            if (
              this.items.filter(
                (i) => i.tipo == "veicoli" && i.id === e.id_macchina
              )?.length > 0
            ) {
              this.items.push({
                tipo: "autisti",
                id: e.id_conduttore,
                id_rif: e.id_macchina,
                des: "",
                expand: false,
                livello: 4,
              });
            }
          });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        }
      });
    },
    async getAutisti() {
      const getconduttori = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getconduttori",
          token: localStorage.getItem("user_token"),
        },
      };
      await this.$store.dispatch("api6", getconduttori).then((res) => {
        if (res.status === 200) {
          res.data.result.forEach((e) => {
            if (
              this.items.filter(
                (i) => i.tipo == "autisti" && i.id === e.id_conduttore
              )?.length > 0
            ) {
              this.items
                .filter((i) => i.tipo == "autisti" && i.id === e.id_conduttore)
                .forEach((a) => (a.des = e.cognome + " " + e.nome));
            }
            this.items[this.items.length - 1].des =
              e.cognome + " " + e.nome;
          });
          this.getEccezioniLista(4);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    sortItems(array, tree, id_padre, livello) {
      let tempItems=array.filter((i)=>i.livello==livello)
      tempItems.forEach((i)=>{
        let id_padre_temp = i.id_rif? i.id_rif.toString():""
        if (id_padre_temp===id_padre.toString()) {
          tree.push(i);
          this.sortItems(array, tree, i.id, livello+1);
        }
      })
    },
  },
  async mounted() {
    this.overlay = true;
    await this.getTabelle();
    await this.getSedi();
    await this.getReparti();
    await this.getMacchine();
    await this.getConduttoriMacchine();
    await this.getAutisti();
    await this.sortItems(this.items, this.items_treeview, "", 0);
    this.overlay = false;
  },
};
</script>
<style scoped></style>